import {
    FETCH_PRODUCT_AVAILABILITY,
    FETCH_PRODUCT_AVAILABILITY_FAILURE,
} from 'store/actions/types';

export const fetchProductAvailabilty = (payload) => {
    return {
        type: FETCH_PRODUCT_AVAILABILITY,
        payload: payload,
    };
};

export const fetchProductAvailabilityFailure = (error) => {
    return {
        type: FETCH_PRODUCT_AVAILABILITY_FAILURE,
        error: error,
    };
};



// WEBPACK FOOTER //
// ./src/store/actions/products/productAvailibity.js